import { PaginatedResults, PaginationInfo } from '@stylehaven/components';
import { ApiList } from '../entities/api-list.entity';

export const ApiListToPaginatedResults = <T, R = T>(
    apiList: ApiList<T>,
    resultsPerPage: number | undefined,
    converter: (item: T) => R = item => item as any as R
) => {
    const paginationInfo: PaginationInfo = {
        totalNumberOfResults: apiList.TotalNrOfResults,
        page: apiList.StartIndex / Number(resultsPerPage),
        resultsPerPage: Number(resultsPerPage)
    };

    const paginatedResults: PaginatedResults<R> = {
        paginationInfo,
        results: apiList.Results?.map(converter)
    };

    return paginatedResults;
};
